import React from "react";
import PropTypes from "prop-types";
import DatePicker from "antd/lib/date-picker";
import { Moment } from "@/components/proptypes";

const MonthInput = React.forwardRef(({ defaultValue, value, onSelect, className, ...props }, ref) => {
  const additionalAttributes = {};
  if (defaultValue && defaultValue.isValid()) {
    additionalAttributes.defaultValue = defaultValue;
  }
  if (value === null || (value && value.isValid())) {
    additionalAttributes.value = value;
  }
  return (
    <DatePicker
      ref={ref}
      className={className}
      picker="month"
      {...additionalAttributes}
      format="YYYY-MM"
      placeholder="Select Month"
      onChange={onSelect}
      {...props}
    />
  );
});

MonthInput.propTypes = {
  defaultValue: Moment,
  value: Moment,
  onSelect: PropTypes.func,
  className: PropTypes.string,
};

MonthInput.defaultProps = {
  defaultValue: null,
  value: undefined,
  onSelect: () => {},
  className: "",
};

export default MonthInput;
